/* 
  quick-filter-custom.js
  Created 11/16/2025 by MC
  Last Editted 11/20/2025 by MC
*/

//console.log('quick-filter-custom.js loaded');

window.sectionInstances = window.sectionInstances || new WeakMap();
window.initScriptOnDemand = window.initScriptOnDemand || ((el, fn) => fn());

function waitForNiceSelect(assignFn, nextSelect) {
  if (typeof NiceSelect !== 'undefined') {
    assignFn(nextSelect);
  } else {
    //console.warn('Waiting for NiceSelect to load...');
    setTimeout(() => waitForNiceSelect(assignFn, nextSelect), 50);
  }
}

/*Use to debug 
setTimeout(() => {
  console.log('NiceSelect is:', typeof NiceSelect);
}, 3000);*/


/*function waitForNiceSelect(assignFn) {
  if (typeof NiceSelect !== 'undefined') {
    assignFn();
  } else {
    console.warn('Waiting for NiceSelect to load...');
    setTimeout(() => waitForNiceSelect(assignFn), 50);
  }
}*/

if (!customElements.get('quick-filter-custom')) {
  class QuickFilter extends HTMLElement {
    constructor() {
      super();

      // Bind lifecycle methods
      this.init = this.doInit.bind(this);
      this.handleSelectChange = this.handleSelectChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);

      // Reinit on Shopify section reorder
      document.addEventListener('shopify:section:reorder', (evt) => {
        if (evt.target.contains(this)) {
          //console.log('Section reorder detected');
          setTimeout(() => this.destroy(), 100);
          setTimeout(() => this.init(), 500);
        }
      });
    }

    connectedCallback() {
      //console.log('connectedCallback fired');
      this.destroy();
      if (window.sectionInstances.has(this)) return;
      window.sectionInstances.set(this, true);
      window.initScriptOnDemand(this, this.init.bind(this));
    }

    disconnectedCallback() {
      //console.log('disconnectedCallback fired');
      this.destroy();
    }

    destroy() {
      //console.log('destroy() called');

      try { this.niceSelect1?.destroy(); } catch (err) {}
      try { this.niceSelect2?.destroy(); } catch (err) {}
      try { this.niceSelect3?.destroy(); } catch (err) {}

      this.querySelectorAll('.nice-select').forEach(el => el.remove());

      this.select1?.removeAttribute('style');
      this.select2?.removeAttribute('style');
      this.select3?.removeAttribute('style');

      this.select1?.removeEventListener('change', this.handleSelectChange);
      this.select2?.removeEventListener('change', this.handleSelectChange);
      this.select3?.removeEventListener('change', this.handleSelectChange);
      this.button?.removeEventListener('click', this.handleSubmit);
    }

    doInit() {
    //console.log('doInit running');

    // Re-query dropdowns and button
    this.select1 = this.querySelector('.js-filter-select-1');
    this.select2 = this.querySelector('.js-filter-select-2');
    this.select3 = this.querySelector('.js-filter-select-3');
    this.button = this.querySelector('.js-filter-submit');

    /*Use to debug 
    if (!this.select1 || !this.select2 || !this.select3 || !this.button) {
      console.warn('Missing dropdowns or button — skipping init');
      return;
    }*/

    if (!this.select1 || !this.select2 || !this.select3 || !this.button) return;

    // Remove duplicate rows
    const rows = this.querySelectorAll('.quick-filter__row');
    rows.forEach((row, index) => {
      if (index > 0) {
        //console.warn('Removing duplicate row:', row);
        row.remove();
      }
    });

    const row = this.querySelector('.quick-filter__row');
    if (!row || row.classList.contains('initialized')) {
      console.log('Already initialized — skipping');
      return;
    }
    row.classList.add('initialized', 'is-loading');

    // Attach event listeners
    this.select1.addEventListener('change', this.handleSelectChange.bind(this));
    this.select2.addEventListener('change', this.handleSelectChange.bind(this));
    this.select3.addEventListener('change', this.handleSelectChange.bind(this));
    this.button.addEventListener('click', this.handleSubmit?.bind(this));

    // Extract metadata from data-url
    [this.select1, this.select2, this.select3].forEach(select => {
      Array.from(select?.options || []).forEach(option => {
        const url = option.dataset.url;
        if (!url) return;
        const makeMatch = url.match(/collections\/([^/?]+)/);
        const modelMatch = url.match(/model=([^&]+)/);
        const genMatch = url.match(/gen=([^&]+)/);
        if (makeMatch) option.dataset.make = makeMatch[1].toLowerCase();
        if (modelMatch) option.dataset.model = modelMatch[1].toLowerCase();
        if (genMatch) option.dataset.generation = decodeURIComponent(genMatch[1]);
      });
    });

    // Store original options
    this.originalOptions = {
      select2: Array.from(this.select2.options),
      select3: Array.from(this.select3.options)
    };

    // Preselect from URL
    const params = new URLSearchParams(window.location.search);
    const make = params.get('make');
    const model = params.get('model');
    const gen = params.get('gen');

    if (make) this.select1.value = make;
    if (model) this.select2.value = model;
    if (gen) this.select3.value = gen;

    /*if (make) this.handleSelectChange({ target: this.select1 });
    if (model) this.handleSelectChange({ target: this.select2 });
    console.log('Preselecting:', { make, model, gen });
    console.log('Selected values:',
    {
      select1: this.select1.value,
      select2: this.select2.value,
      select3: this.select3.value
    });*/

    // Added to ensure Model and Generation is disabled on initial load of quick-filter-custom
    this.select1.style.display = '';
    this.select2.style.display = '';
    this.select3.style.display = '';

    this.select2.disabled = true;
    this.select3.disabled = true;

      // Bind NiceSelect to all three selects
    [this.select1, this.select2, this.select3].forEach((select, index) => {
        waitForNiceSelect(() => {
          //console.log(`Attempting to bind select ${index + 1}:`, select);
          if (select === this.select1) {
            this.niceSelect1?.destroy?.();
            this.niceSelect1 = NiceSelect.bind(this.select1, { searchable: false });
            //console.log('Bound niceSelect1:', this.niceSelect1);
          } else if (select === this.select2) {
            this.niceSelect2?.destroy?.();
            this.niceSelect2 = NiceSelect.bind(this.select2, { searchable: false });
            //console.log('Bound niceSelect2:', this.niceSelect2);
          } else if (select === this.select3) {
            this.niceSelect3?.destroy?.();
            this.niceSelect3 = NiceSelect.bind(this.select3, { searchable: false });
            //console.log('Bound niceSelect3:', this.niceSelect3);
          }
        });
      });

    // Finalize layout
    /*requestAnimationFrame(() => {
      row.classList.remove('is-loading');
      row.classList.add('is-ready');

      if (window.innerWidth >= 768) {
        row.style.marginTop = '-22px';
        row.style.marginBottom = '6px';
      }
    });*/

    requestAnimationFrame(() => {
      row.classList.remove('is-loading');
      row.classList.add('is-ready');

      // Desktop layout tweak
      if (window.innerWidth >= 768) {
        row.style.marginTop = '-22px';
        row.style.marginBottom = '6px';
      }

      // Safari fix: force reflow
      row.style.display = 'none';
      void row.offsetHeight; // trigger reflow
      row.style.display = '';
    });
    
  }
    handleSelectChange(event) {
      const currentSelect = event.target;
      const selectedOption = currentSelect.options[currentSelect.selectedIndex];
      const nextSelect =
        currentSelect === this.select1 ? this.select2 :
        currentSelect === this.select2 ? this.select3 : null;

      if (!selectedOption.dataset.url || selectedOption.dataset.url === '#') {
        this.button.setAttribute('disabled', 'disabled');
      } else {
        this.button.removeAttribute('disabled');
      }

      if (!nextSelect) return;

      const normalize = str => (str || '').toLowerCase().trim();
      const selectedMake = normalize(this.select1.options[this.select1.selectedIndex]?.dataset.make);
      const selectedModel = normalize(this.select2.options[this.select2.selectedIndex]?.dataset.model);

      const originalOptions =
        nextSelect === this.select2 ? this.originalOptions.select2 :
        nextSelect === this.select3 ? this.originalOptions.select3 : [];

      const placeholder = originalOptions[0].cloneNode(true);
      let optionsShown = 0;

      nextSelect.innerHTML = '';
      nextSelect.appendChild(placeholder);

      originalOptions.slice(1).forEach(option => {
        const matchesMake = option.dataset.make === selectedMake;
        const matchesModel = option.dataset.model === selectedModel;

        const shouldShow =
          currentSelect === this.select1 ? matchesMake :
          currentSelect === this.select2 ? matchesMake && matchesModel : false;

        if (shouldShow) {
          const newOption = document.createElement('option');
          Object.assign(newOption, {
            value: option.value,
            textContent: option.textContent
          });
          Object.assign(newOption.dataset, option.dataset);
          nextSelect.appendChild(newOption);
          optionsShown++;
        }
      });

      nextSelect.disabled = optionsShown === 0;
      nextSelect.selectedIndex = 0;

      nextSelect.disabled = optionsShown === 0;
      nextSelect.selectedIndex = 0;

      // Delay binding until DOM is fully updated
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (typeof NiceSelect === 'undefined') {
            console.warn('NiceSelect not loaded — skipping');
            return;
          }
          if (nextSelect === this.select2) {
            this.niceSelect2?.destroy();
            this.niceSelect2 = NiceSelect.bind(this.select2, { searchable: false });
          } else if (nextSelect === this.select3) {
            this.niceSelect3?.destroy();
            this.niceSelect3 = NiceSelect.bind(this.select3, { searchable: false });
          }
        });
      });

      requestAnimationFrame(() => {
        if (nextSelect === this.select2) {
          this.niceSelect2?.destroy();
          this.niceSelect2 = NiceSelect.bind(this.select2, { searchable: false });
        } else if (nextSelect === this.select3) {
          this.niceSelect3?.destroy();
          this.niceSelect3 = NiceSelect.bind(this.select3, { searchable: false });
        }
      });

      
      // Reset Generation if Make changes
      if (currentSelect === this.select1) {
        this.select3.innerHTML = '';
        this.originalOptions.select3.forEach(opt => this.select3.appendChild(opt.cloneNode(true)));
        this.select3.selectedIndex = 0;
        this.select3.disabled = true;

        this.niceSelect3?.destroy();
        this.niceSelect3 = NiceSelect.bind(this.select3, { searchable: false });
      }
    }

    handleSubmit() {
      const selects = [this.select3, this.select2, this.select1];
      for (const select of selects) {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption?.dataset.url && selectedOption.dataset.url !== '#') {
          window.location.href = this.makeAbsoluteUrl(selectedOption.dataset.url);
          break;
        }
      }
    }

    makeAbsoluteUrl(url) {
      return url.includes(window.location.origin)
        ? url
        : window.location.origin + (url.startsWith('/') ? url : '/' + url);
    }
  }

    customElements.define('quick-filter-custom', QuickFilter);

  // Re-run init when Shopify reloads section
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.matches('quick-filter-custom, .quick-filter-custom')) {
      section.doInit?.();
    }
  });
}

// Firefox bfcache fix
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    document.querySelectorAll('.nice-select').forEach(el => el.remove());
    document.querySelectorAll('quick-filter-custom').forEach(el => {
      el.destroy?.();
      el.init?.();
    });
  }
});